export const SEO_SLUG_CACHE_KEYS = {
  LIST: () => ["seo-slugs", "LIST"],
};
